import {identity, constant} from 'lodash';
import type {QueryInfo} from '../types';

const noopQueryAdapterResult = {data: null, setDynamoEnv: identity} as const;

export const noopQueryAdapter: QueryInfo['adapter'] = constant(
  noopQueryAdapterResult
);

export const noopQueryInfo: QueryInfo = {
  query: null,
  adapter: noopQueryAdapter,
  variables: {query: '', publishTarget: ''},
};
